module.exports = __webpack_public_path__ + "img/about-us.893398fc.jpg";